import { render, staticRenderFns } from "./RoomDiceChip.vue?vue&type=template&id=8e12cccc&lang=pug&"
import script from "./RoomDiceChip.vue?vue&type=script&lang=ts&"
export * from "./RoomDiceChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomDiceChip.vue"
export default component.exports